import React from 'react';
import { Redirect, Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import ScrollToTop from './components/ScrollToTop';
import CachedResponse from './components/common/CachedResponse';
import Loader from './components/Loader';
import useClientTitle from './hooks/useClientTitle';
import useScrollBlockForNumberInput from './hooks/useScrollBlockForNumberInput';
import useSessionProbe from './hooks/useSessionProbe';
import Home from './pages/home';
import Login from './pages/login';
import RequestService from './pages/service_request';
import WalkthroughConfirmation from './pages/walkthrough_confirmation';
import DevEnvIndicator from './components/DevEnvIndicator';

function AuthenticatedHomeShell() {
  const { sessionReady, isLoggedIn } = useSessionProbe({ persistProfile: true });
  if (!sessionReady) {
    return <Loader />;
  }
  if (!isLoggedIn) {
    const returnTo = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    const redirect = returnTo && returnTo !== '/' ? `?redirect=${encodeURIComponent(returnTo)}` : '';
    return <Redirect to={`/login${redirect}`} />;
  }
  return <CachedResponse listEndpoint={'app-choices'} render={appChoices => <Home appChoices={appChoices} />} />;
}

const App = () => {
  useClientTitle();
  useScrollBlockForNumberInput();

  return (
    <Router>
      <ScrollToTop />
      {/* A <Switch> looks through its children <Route>s and
              renders the first one that matches the current URL. */}
      <Switch>
        <Route exact path="/login">
          <Login />
        </Route>
        <Route exact path="/request_service">
          <RequestService />
        </Route>
        <Route exact path="/walkthrough_confirmation/:uuid">
          <WalkthroughConfirmation />
        </Route>
        <Route path="/">
          <AuthenticatedHomeShell />
        </Route>
      </Switch>
      <DevEnvIndicator />
      <ToastContainer autoClose={2000} />
    </Router>
  );
};

export default App;
